import MediaAttribute from '../utils/data/media_attribute';

export default class DashAdapter {
  constructor(instance) {
    this._instance = instance;
  }

  instance() {
    return this._instance;
  }

  vhsObject() {
     return this.instance().tech({ IWillNotUseThisInPlugins: true }).vhs
  }

  hasDashObject() {
    return !this.vhsObject() && !!this.dash();
  }

  dash() {
    return this.instance().dash
  }

  mediaPlayer() {
    return this.instance().dash.mediaPlayer;
  }

  enableAutoSwitchQuality() {
    this.mediaPlayer().resetSettings();
  }

  setVideoQuality(index) {
    this.mediaPlayer().updateSettings({
      streaming: {
        fastSwitchEnabled: true,
        abr: {
          autoSwitchBitrate: {
            video: false
          }
        }
      }
    });
    this.mediaPlayer().setQualityFor('video', index);
  }

  rawRepresentations() {
    if (this.hasDashObject()) {
      return this.mediaPlayer().getBitrateInfoListFor('video');
    } else {
      return [];
    }
  }

  representations() {
    return this.rawRepresentations().map((representation) => {
      representation.enable = () => {
        this.setVideoQuality(representation.qualityIndex);
      };
      return representation;
    });
  }

  getCurrentMediaAttribute() {
    if (this.hasDashObject() == false) return MediaAttribute.invalid();

    const activeIdx = this.mediaPlayer().getQualityFor('video');
    const rawRep = this.mediaPlayer().getBitrateInfoListFor('video');

    if (rawRep[activeIdx] == undefined) return MediaAttribute.invalid();

    return new MediaAttribute(rawRep[activeIdx].width, rawRep[activeIdx].height, rawRep[activeIdx].bitrate);
  }
}
